import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { TrustBadges } from './TrustBadges';
import { trackAddToCart } from '../utils/metaPixel';
const faqs = [{
  question: '¿Cuándo recibo el acceso?',
  answer: 'Inmediatamente. Al completar tu orden, recibirás un correo con acceso instantáneo al Premium Pack completo.'
}, {
  question: '¿Funciona realmente en 72 horas?',
  answer: 'La ansiedad aguda y la necesidad desesperada de contacto pueden neutralizarse en 72 horas aplicando las tácticas correctas. El dolor profundo toma más tiempo, pero el control vuelve rápido.'
}, {
  question: '¿Es solo para mujeres?',
  answer: 'El lenguaje está dirigido a la experiencia femenina, pero los principios psicológicos aplican para cualquier persona atravesando una ruptura.'
}, {
  question: '¿Qué formato tiene?',
  answer: 'Paquete 100% digital. Ebook y journal en PDF, audio SOS en MP3. Funciona en cualquier dispositivo con total privacidad.'
}];
export function PricingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="pricing" className="py-5 px-6 bg-black border-t border-gold/10" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-6" data-id="element-106">
          <p className="font-sans text-[10px] text-gold uppercase tracking-[0.3em] mb-2" data-id="element-107">
            Inversión en tu paz mental
          </p>
          <div className="flex flex-col items-center gap-1 mb-4" data-id="element-108">
            <span className="font-sans text-lg text-gray-600 line-through font-light tracking-widest" data-id="element-109">
              $29.990
            </span>
            <span className="font-cinzel text-5xl md:text-7xl text-white tracking-[0.1em]" data-id="element-110">
              $14.990
            </span>
            <span className="font-sans text-[10px] text-gold/40 uppercase tracking-[0.2em] mt-1" data-id="element-111">
              Pesos Argentinos
            </span>
          </div>

          <div className="w-full max-w-sm mx-auto" data-id="element-112">
            <a href="https://tutiendadigi.shop/cart/51868811428120:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full py-5 bg-gold text-black font-sans font-semibold text-sm tracking-[0.15em] uppercase text-center hover:bg-gold-light transition-colors duration-300 mb-4" data-id="element-113">
              acceso inmediato — $14.990
            </a>
            <TrustBadges data-id="element-114" />
          </div>
        </motion.div>

        {/* FAQ */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-115">
          <h3 className="font-cinzel text-xl text-white text-center mb-4 tracking-[0.15em]" data-id="element-116">
            PREGUNTAS FRECUENTES
          </h3>

          <div className="space-y-0" data-id="element-117">
            {faqs.map((faq, index) => <div key={index} className="border-b border-white/5" data-id="element-118">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-3 flex items-center justify-between text-left focus:outline-none group" data-id="element-119">
                  <span className="font-sans text-sm text-gray-300 font-light tracking-wide group-hover:text-gold transition-colors" data-id="element-120">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-4 h-4 text-gold/40 transition-transform duration-500 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-121" />
                </button>
                <AnimatePresence data-id="element-122">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.4,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-123">
                      <div className="pb-3 font-sans text-sm text-gray-500 font-light leading-loose pr-8" data-id="element-124">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}